/**
 * CSV que abre bem no Excel em português (';', BOM UTF-8, CRLF) sem injecção
 * de fórmulas (OWASP CSV Injection) — portado de fact_csv_safe(). Uma só
 * implementação para o ficheiro da AT (servidor) e os relatórios (browser).
 */
/** Neutraliza um valor que o Excel leria como fórmula. Números, incluindo negativos, ficam intactos. */
export function csvSafe(v) {
    if (v === '' || /^-?\d+(\.\d+)?$/.test(v))
        return v;
    return /^[=+\-@\t\r]/.test(v) ? `'${v}` : v;
}
/** Célula: neutraliza PRIMEIRO e só depois põe aspas — o Excel tira as aspas antes de interpretar. */
export function csvCell(v) {
    const s = csvSafe(String(v));
    return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
/** Ficheiro completo: BOM, ';' entre colunas, CRLF entre linhas. */
export function csvDocument(rows) {
    return '﻿' + rows.map((r) => r.map(csvCell).join(';')).join('\r\n');
}
//# sourceMappingURL=csv.js.map